export type StatisticsCurrency = 'EUR' | 'LEI';

/**
 * Return the Lei-per-EUR display factor for a money reference line. Invalid rates,
 * EUR displays, and non-money series intentionally use a neutral factor of one.
 */
export function referenceDisplayFactor(
    currency: StatisticsCurrency | undefined,
    exchangeRate: number | undefined,
    convertCurrency: boolean,
): number {
    if (!convertCurrency || currency !== 'LEI') return 1;
    if (!exchangeRate || exchangeRate <= 0) return 1;
    return exchangeRate;
}

/** Convert a canonical EUR reference into the currently displayed currency. */
export function toDisplayReference(canonicalEur: number, factor: number): number {
    return Math.round(canonicalEur * factor);
}

/** Convert a displayed reference back into the canonical EUR value to persist. */
export function toCanonicalReference(displayValue: number, factor: number): number {
    return factor === 1 ? displayValue : displayValue / factor;
}
